import type { FunctionComponent } from "react";
import { Text } from "@smartsuite/react-ui/lib";

import { TextFieldWrapper } from "../TextFieldWrapper/TextFieldWrapper";

interface TextFieldProps {
  value: string;
}

export const TextField: FunctionComponent<TextFieldProps> = ({ value }) => {
  return (
    <TextFieldWrapper>
      <Text>{value}</Text>
    </TextFieldWrapper>
  );
};
